"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentMethods = exports.getMop_bff = exports.updateMop_bff = exports.createMop_bff = exports.methodOfPaymentGraphRequestToCheggResponse = exports.formatCreateUpdateMopResponse = exports.mapCreateUpdateMopInput = void 0;
var tslib_1 = require("tslib");
var index_1 = require("../../common/index");
var interfaces_1 = require("../../common/interfaces");
var common_1 = require("../../common");
var transformClientBillingAddressToBffInput_1 = require("../../common/transforms/transformClientBillingAddressToBffInput");
var constants_1 = require("./constants");
var constants_2 = require("../constants");
var interfaces_2 = require("./interfaces");
function mapCreateUpdateMopInput(mop) {
    return {
        input: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, mop), { accountType: interfaces_2.createUpdateMopInputAccountTypeMap[mop.accountType || 'credit card'] }), (mop.paymentProcessor
            ? {
                paymentProcessor: mop.paymentProcessor || constants_2.PAYMENT_PROCESSOR_TYPE.BRAINTREE,
            }
            : {})), (mop.billing && {
            billing: (0, transformClientBillingAddressToBffInput_1.transformClientBillingAddressToBffPaymentServiceInput)(mop.billing),
        })),
    };
}
exports.mapCreateUpdateMopInput = mapCreateUpdateMopInput;
function formatCreateUpdateMopResponse(_a) {
    var data = _a.data, errors = _a.errors, success = _a.success;
    return {
        data: tslib_1.__assign(tslib_1.__assign({}, data), { errors: null, errors2: errors ? errors : null }),
        errors: errors,
        success: success,
    };
}
exports.formatCreateUpdateMopResponse = formatCreateUpdateMopResponse;
function methodOfPaymentGraphRequestToCheggResponse(_a) {
    var _b;
    var data = _a.data, errors = _a.errors, success = _a.success;
    var baseErrors = null;
    if (errors && success) {
        var requestFailureError = errors.find(function (error) {
            var _a, _b;
            var errorCode = (_b = (_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : '';
            return errorCode in constants_1.GRAPHQL_PAYMENT_ERRORS;
        });
        baseErrors = ((_b = requestFailureError === null || requestFailureError === void 0 ? void 0 : requestFailureError.extensions) === null || _b === void 0 ? void 0 : _b.formattedErrors) || errors;
        baseErrors = (0, common_1.addErrorType)(baseErrors, interfaces_1.ErrorType.SERVER);
        success = false;
    }
    return formatCreateUpdateMopResponse({
        errors: baseErrors,
        data: data,
        success: errors && errors.length > 0 ? false : success,
    });
}
exports.methodOfPaymentGraphRequestToCheggResponse = methodOfPaymentGraphRequestToCheggResponse;
function createMop_bff(mop) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, (0, index_1.sendBFFCall)(interfaces_1.GraphQLOperations.CREATE_MOP, mapCreateUpdateMopInput(mop))
                    .then(methodOfPaymentGraphRequestToCheggResponse)
                    .catch(function (error) {
                    return JSON.parse(error.message);
                })];
        });
    });
}
exports.createMop_bff = createMop_bff;
function updateMop_bff(mop) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, (0, index_1.sendBFFCall)(interfaces_1.GraphQLOperations.UPDATE_MOP, mapCreateUpdateMopInput(mop))
                    .then(methodOfPaymentGraphRequestToCheggResponse)
                    .catch(function (error) { return JSON.parse(error.message); })];
        });
    });
}
exports.updateMop_bff = updateMop_bff;
function getMop_bff(filter) {
    var _a, _b;
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var bffVariables;
        return tslib_1.__generator(this, function (_c) {
            if (((_a = filter === null || filter === void 0 ? void 0 : filter.paymentMethods) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                return [2 /*return*/, Promise.resolve({
                        data: [],
                        errors: null,
                        success: true,
                    })];
            }
            bffVariables = {
                input: {
                    fActiveFlag: 'true',
                    methodOfPaymentTypes: ((_b = filter === null || filter === void 0 ? void 0 : filter.paymentMethods) === null || _b === void 0 ? void 0 : _b.map(function (value) { return interfaces_2.getMopInputAccountTypeMap[value]; })) || [],
                },
            };
            return [2 /*return*/, (0, index_1.sendBFFCall)(interfaces_1.GraphQLOperations.GET_MOP, bffVariables).catch(function (error) { return JSON.parse(error.message); })];
        });
    });
}
exports.getMop_bff = getMop_bff;
function getPaymentMethods(countryCode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, (0, index_1.sendBFFCall)('GET_PAYMENT_METHODS_OPERATION_NAME', {
                    input: {
                        countryCode: countryCode,
                    },
                }).catch(function (error) { return JSON.parse(error.message); })];
        });
    });
}
exports.getPaymentMethods = getPaymentMethods;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/bff/index.js
// module id = 3388
// module chunks = 11